import React, { useEffect } from 'react';
import EnergypageBanner from './EnergypageBanner';
import HealthcareAboutdata from './HealthcareAboutdata';
import Healthverticalcards from './Healthverticalcards';
import Healthcarecards from './Healthcarecards';
import AerospaceInsightsCards from './AerospaceInsightsCards';
import Bankpagedata from './Bankpagedata';
import BankingVerticalTabs from './BankingVerticalTabs';
import Bankinghoveredcards from './Bankinghoveredcards';

import Bfsibuttons from './Bfsibuttons';
import Footer from './Footer';
import Itrequestform from './Itrequestform';
import CregotBfsipage from './CregotBfsipage';
import Bfsimobilecrigot from './Bfsimobilecrigot';
import Bfsisecondverticaltab from './Bfsisecondverticaltab';
import Bfsitridtab from './Bfsitridtab';
const EnergyPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []); // Empty dependency array ensures it only runs once when the component mounts
  // Scroll to the top of the page when the component mounts

  return (
    <div style={{ background: '#fff' }}>
      <EnergypageBanner />
      <Bfsibuttons />
      {/* <HealthcareAboutdata  /> */}
      <Bankpagedata />
      <BankingVerticalTabs  />
      <Bfsisecondverticaltab />  
      <Bfsitridtab />
      {/* <Healthverticalcards /> */}
      <CregotBfsipage  />
    
      <div className='mobile-crigot'>
      <Bfsimobilecrigot />
      </div>
   {/* <Bankinghoveredcards /> */}
      {/* <Healthcarecards  /> */}
      {/* <AerospaceInsightsCards /> */}

      <br></br>      
      <Itrequestform  />
      <div style={{marginTop:"-60px"}}>
      <Footer />  
      </div>


      {/* <style>
        {`
           h1,h2,h3,h4,h5,h6,p{
          font-family: urbanist , sarif;
          }
          `}
      </style> */}
      <style>
        {`
          body, h1, h2, h3, h4, h5, h6, p {
            font-family: "Helvetica Neue", sans-serif !important;
          }
        `}
      </style>
    </div>
  )
}

export default EnergyPage;